module.exports = __webpack_public_path__ + "img/fish5.12e74505.png";